module.exports = __webpack_public_path__ + "img/14.7ac65987.png";